import { Entry } from 'contentful';
import { IBlogAuthorFields } from 'global';
import type { ArticleCard } from 'modules/magazine/contentful';
import { useContentful } from 'modules/content-cms/components/context';
import Author from 'modules/content-cms/sections/author';
import React from 'react';

interface AuthorPageComponentProps {
  articles: Entry<ArticleCard>[] | undefined;
}

const AuthorPageComponent: React.FC<AuthorPageComponentProps> = ({ articles }) => {
  const { data: contentful } = useContentful<Entry<IBlogAuthorFields>>();

  return <Author {...contentful.fields} articles={articles} />;
};

export default AuthorPageComponent;
